import gql from 'graphql-tag';

export const OPERATIONS_INPUT = gql`
  fragment operation on Operation {
    admin{
      id
    }
    harold_number
    marketType
    consignee{
      id
    }
    consigneeCompanies{
      id
    }
    agent
    company{
      id
    }
    endDate
    isWM
    dateOfCreation
    dateOfClosing
    maxNumberOfContainers
    notifyParties{
      id
    }
    origin
    paymentPercentage
    photos
    placeOfDelivery
    agentCommission {
      quantity
      currency
      volume
    }
    billingEntity
    cancellationReason
    comment
    createdBy {
      id
      firstName
      lastName
      organizationId
    }
    id
    incoterm
    isPaymentReceived
    margin {
      currency
      precision
      quantity
      volume
    }
    mqc
    paymentTerms
    portOfDestination
    portOfLoading
    referenceNumber
    origin
    type
    site {
      id
      name
      type
      region
      subregion
      paymentTerms
    }
    status
    price {
      quantity
      volume
      currency
      precision
    }
    priceCost {
      quantity
      volume
      currency
    }
    limitPrice {
      quantity
      volume
      currency
    }
    
    quantity {
      quantity
      volume
    }
    targetCost {
      quantity
      volume
      currency
    }
    qualities{
      averageQuantity{
        quantity
        volume
      }
      comment
      conditionning
      description
      estimatedLogisticCost{
        currency
        quantity
        volume
      }
      exchangeRate{
        rate
      }
      hsCode
      impuritiesPercentage
      incoterm
      isHedgingRequired
      logisticMaterial
      maxQuantityToLoad{
        quantity
        volume
      }
      mqcQuantity
      mqcVolume
      numberOfContainers
      parentOperationQualityId
      pdfDisplayName
      price{
        currency
        quantity
        volume
      }
      priceType
      quality {
        id
        group
        name
      }
      quantity{
        quantity
        volume
      }
      quantityToleranceRate
      shippingMark
      shortageAllowedPercentage
      stockpile{
        id
      }
      warehouseQuality{
        id
      }
      indexDifferential
      indexFormula
      indexFormulaPdfDisplayName
      indexName
      indexName2
      indexOtherCosts
      indexPeriod
      indexPeriod2
      indexPriceVolume
      indexQpDays
      indexQuotationalPeriodTerm
      indexQuotationalPeriodTermEndDate
      indexQuotationalPeriodTermStartDate
      indexRecovery
      indexReferenceDateOrPeriod
      indexTiming
      indexTiming2
      indexValue
      indexValue2
      indexValuePercentage
      indexValuePercentage2
      isTemporaryPrice
      priceIndex
    }
    releaseType
    shipmentMode
    shouldBeSentToContact
    site{
      id
    }
    status
    subdivision
    type
  }
`;
